import React, { useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { Icon, Text, TextInput, useTheme } from 'react-native-paper';

export interface TextFormFieldProps {
    label: string;
    value: string;
    onChangeText?: (text: string) => void;
    setHasError?: (hasError: boolean) => void;
    editable?: boolean;
    mode?: 'flat' | 'outlined';
    secureTextEntry?: boolean;
    viewStyle?: StyleProp<ViewStyle>;
    validators?: Array<(text: string) => string | null | undefined>;
}

const TextFormField: React.FC<TextFormFieldProps> = ({ viewStyle, label, value, onChangeText, setHasError, editable, mode, secureTextEntry, validators }) => {
    const theme = useTheme();

    const [error, setError] = useState(false);
    const [errorMessages, setErrorMessages] = useState<string[] | undefined>(undefined);

    const [_secureTextEntry, _setSecureTextEntry] = useState(secureTextEntry);
    const [_showSecureText, _setShowSecureText] = useState(secureTextEntry);

    const togleSecureText = () => {
        _setShowSecureText(!_showSecureText);
        _setSecureTextEntry(!_showSecureText);
    };

    const _onChangeText = (text: string) => {
        if (validators) {
            const errors = validators.map((validator) => validator(text)).filter((msg) => msg != null) as string[];
            setError(errors.length > 0);
            setErrorMessages(errors.length > 0 ? errors : undefined);

            setHasError?.(errors.length > 0);
        }

        onChangeText?.(text);
    }

    return (
        <View style={viewStyle}>
            <TextInput
                style={{ flex: 1 }}
                label={label}
                value={value}
                onChangeText={_onChangeText}
                mode={mode}
                error={error}
                editable={editable}
                secureTextEntry={_secureTextEntry}
                right={secureTextEntry ?
                    <TextInput.Icon
                        color={theme.colors.onSurfaceVariant}
                        icon={_showSecureText ? "eye" : "eye-off"}
                        onPress={togleSecureText} />
                    : undefined}
            />
            <View style={{ minHeight: 20 }}>
                {error && errorMessages &&
                    <Text style={{ color: theme.colors.error }}>{errorMessages.join(", ")}</Text>
                }
            </View>
        </View>
    );
}

export default TextFormField;
